import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';

const AppLocalizationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { getLanguage, getLocaleForDayjs } = useTranslation();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={getLocaleForDayjs(getLanguage).name}>
      {children}
    </LocalizationProvider>
  );
};

export default AppLocalizationProvider;
